import React from "react";
import { Link } from "../router";
import Logo from "./Logo";

const COLS = [
  {
    head: "Portfolio",
    links: [
      { to: "/properties?class=Apartments", label: "Apartments" },
      { to: "/properties?class=Villas", label: "Villas" },
      { to: "/properties?class=Houses", label: "Houses" },
      { to: "/properties?class=Plots", label: "Plots" },
      { to: "/properties?class=Land", label: "Land" },
    ],
  },
  {
    head: "Services",
    links: [
      { to: "/sell", label: "List an Asset" },
      { to: "/buy", label: "Acquire an Asset" },
      { to: "/investors", label: "Wealth & Arbitrage" },
      { to: "/contact", label: "Design & Build Desk" },
      { to: "/contact", label: "Bank Alliance Desk" },
    ],
  },
  {
    head: "The House",
    links: [
      { to: "/about", label: "Our Standard" },
      { to: "/about", label: "Aditi Legal Shield" },
      { to: "/careers", label: "Careers" },
      { to: "/contact", label: "Contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="dark">
      <div className="shell" style={{ paddingTop: "clamp(64px,9vw,120px)", paddingBottom: 48 }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(260px, 1.4fr) repeat(3, minmax(120px, 1fr))",
            gap: "clamp(32px, 4vw, 72px)",
          }}
          className="footer-grid"
        >
          <div>
            <Logo light />
            <p className="muted" style={{ marginTop: 22, maxWidth: 320, fontSize: "0.95rem" }}>
              A curated brokerage and design-build house for people who refuse to
              gamble on title, timelines, or taste. Every asset is vetted twice —
              once by law, once by us.
            </p>
            <div className="flexrow" style={{ marginTop: 26, gap: 10 }}>
              <span className="badge"><span className="dot" /> Aditi Legal Shield</span>
              <span className="badge live"><span className="dot" /> Live Inventory Only</span>
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.head}>
              <h4 style={{ fontFamily: "var(--sans)", fontSize: "0.72rem", letterSpacing: "0.24em", textTransform: "uppercase", color: "var(--champagne)", marginBottom: 20 }}>
                {c.head}
              </h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 13 }}>
                {c.links.map((l, i) => (
                  <li key={i}>
                    <Link to={l.to} className="muted" style={{ fontSize: "0.92rem", transition: "color 0.3s" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "var(--paper-ink)")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "")}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <hr className="rule" style={{ margin: "48px 0 28px" }} />

        <div className="spaced" style={{ fontSize: "0.8rem" }}>
          <span className="muted">© {new Date().getFullYear()} Aditi Realty Holdings. RERA-aligned. All rights reserved.</span>
          <span className="muted" style={{ display: "flex", gap: 22 }}>
            <Link to="/about">Privacy</Link>
            <Link to="/about">Title Vetting Protocol</Link>
            <Link to="/contact">Grievance Desk</Link>
          </span>
        </div>
      </div>

      <style>{`
        @media (max-width: 760px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 460px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
